import React, { Component, PropTypes } from 'react';
import { PresetColorPicker } from '../../../widgets/index';

class GeneralBackgroundGlobal extends Component {
    render() {
        return (
            <div className="GlobalStyles">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <PresetColorPicker
                            color={this.props.color}
                            onColorChange={this.props.onColorChange(this.props.tagName)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

GeneralBackgroundGlobal.propTypes = {
    tagNameName: PropTypes.string,
    tagName: PropTypes.string,
    color: PropTypes.string,
    onColorChange: PropTypes.func
};

export default GeneralBackgroundGlobal;



// WEBPACK FOOTER //
// ./src/components/pages/theme/global/GeneralBackgroundGlobal.js